const iterateEventMap = (element, eventMap, method, beforeArgs = [], afterArgs = []) => {
  Object.keys(eventMap).forEach(event => {
    element[method](...beforeArgs, event, eventMap[event], ...afterArgs);
  });
};

const plain = name => (element, eventMap) => iterateEventMap(element, eventMap, name);

// Node EventEmitter-style events
export const bindEvents   = plain('addListener');
export const unbindEvents = plain('removeListener');

// Socket.io-style events
export const bindSocketEvents   = plain('on');
export const unbindSocketEvents = plain('off');
